<template>
  <toast class="position-translate-center bg-toast-danger border-danger" :autohide="false" ref="toast">
    <toast-body :message="message" />
  </toast>
</template>

<script>
import Toast from '@/views/atoms/Toast'
import ToastBody from '@/views/atoms/ToastBody'

export default {
  name: "ServerErrorToast",
  components: {
    Toast,
    ToastBody,
  },
  data() {
    return {
      message: 'サーバーでエラーが発生しました。\nしばらくしてからもう一度お試しください。',
    }
  },
  methods: {
    show() {
      this.$refs.toast.show();
    },
  },
}
</script>

<style scoped>
.toast {
  width: 400px;
}
</style>
